import { LightGallery as ILightGallery } from 'lightgallery/lightgallery';
import { RefObject } from 'react';

export const useEditButton = (lightGallery: RefObject<ILightGallery | null>, onEditClick: () => void) => {
  return () => {
    const toolbar = document.querySelector('.lg-toolbar');

    if (toolbar && !toolbar.querySelector('.lg-custom-edit')) {
      const editButton = document.createElement('button');
      editButton.className = 'lg-custom-edit lg-icon';
      editButton.id = 'img-editor-button';
      editButton.innerHTML = `<span style="display:flex; justify-content: center;">Editar</span>`;
      editButton.style.cursor = 'pointer';
      editButton.onclick = onEditClick;
      toolbar.appendChild(editButton);
    }
  };
};
